module.exports = __webpack_public_path__ + "static/media/05.a47c468f.png";